import { ApolloClient } from '@apollo/client';
import { AutocompleteRawContext } from '@jupiterone/query-language-autocomplete';
import { BackingStore } from '../backingStore';

export interface LoadAutocompleteData {
  accountId: string;
  expires?: Date;
  client?: ApolloClient<any>;
  backing: BackingStore<AutocompleteRawContext>;
}

export interface AutocompleteDataResult {
  // Immediate result (could be default)
  data: AutocompleteRawContext;

  // Retrieve the latest result (or stored value)
  promise: Promise<{ result: AutocompleteRawContext; isNewData: boolean }>;
}

// TypeScript type guard to determine at runtime if data is AutocompleteContext
export const isAutocompleteData = (
  value: any
): value is AutocompleteRawContext => {
  // NOTE: Must be updated if AutocompleteContext type changes
  return (
    Array.isArray(value.entities) &&
    typeof value.properties === 'object' &&
    value.properties !== null &&
    typeof value.relationships === 'object' &&
    value.relationships !== null
  );
};
